import { connect } from 'react-redux'
import { TracepointRule } from './domain/TracepointRule'
import Loading from './helper/loading'
import { ApplicationState } from './redux/ApplicationState'
import { fetchTracepoint, terminateTracepoint } from './redux/V2/TracepointRule/actions'
import { getTracepointById } from './redux/V2/TracepointRule/TracepointRuleState'
import { RouteComponentProps } from 'react-router'
import React from 'react'
import { PortalContentNavigation } from './helper/portal-content-navigation'
import { TracepointListItem } from './tracepoint-list-item'
import BoxBody from './helper/boxBody'
import { Box } from './ui/box'
import ProfileList from './profile-list'
import { allowedDurationsForTracepoints } from './helper/tracepoints'
import { TidewaysContext } from './app/context'
import moment from 'moment'
import EditTracepointForm from './monitor/operation/tracepoint-form/edit-tracepoint-form'
import VisibilityChange from './visibilityChange'

interface MatchParameters {
    tracepointId: string
}

interface OwnProps {}

interface StateProps {
    tracepoint: TracepointRule<moment.Moment> | null
    tidewaysContext: TidewaysContext
}

interface DispatchProps {
    fetchTracepoint: typeof fetchTracepoint
    terminateTracepoint: typeof terminateTracepoint
}

interface State {
    view: 'edit' | 'show'
    browserActive: boolean
}

type Props = OwnProps & DispatchProps & StateProps & RouteComponentProps<MatchParameters>

class TracepointDetailsComponent extends React.PureComponent<Props, State> {
    private interval: NodeJS.Timer
    private visibility: any
    private visibilityIndex: string
    public constructor(props: Props) {
        super(props)

        this.state = {
            view: 'show',
            browserActive: true,
        }
    }

    private fetchTracepoint = () => {
        this.props.fetchTracepoint(this.props.match.params.tracepointId)
    }

    componentDidMount() {
        this.visibility = new VisibilityChange()
        const { tracepointId } = this.props.match.params
        this.registerCallback(tracepointId)
        this.fetchTracepoint()
        this.setInterval(tracepointId)
    }

    componentDidUpdate(prevProps: Props) {
        const { tracepointId } = this.props.match.params
        if (prevProps.match.params.tracepointId === tracepointId) {
            return
        }
        if (this.interval) {
            clearInterval(this.interval)
        }
        this.visibility.removeCallBack(this.visibilityIndex)
        this.registerCallback(tracepointId)
        this.setInterval(tracepointId)
        this.fetchTracepoint()
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    }

    public render() {
        const { tracepoint } = this.props

        if (!tracepoint) {
            return <Loading />
        }

        const isActive = tracepoint.activeUntil >= moment()

        const duplicateUrl = `tracepoint-rule/${tracepoint.id}/duplicate`
        return (
            <>
                <PortalContentNavigation>
                    <Box>
                        <BoxBody noPadding>
                            <div className={'tracepoint-details-header'}>
                                <table className="table table-condensed">
                                    <tbody>
                                        <TracepointListItem tracepoint={tracepoint} showTraceLinks={false} />
                                    </tbody>
                                </table>
                                {isActive ? (
                                    <div className={'tracepoint-details-actions tw-pr-16'}>
                                        <div className="tw-mr-12">
                                            <a
                                                className="btn btn-default"
                                                onClick={() => {
                                                    this.setState({ view: 'edit' })
                                                }}
                                            >
                                                Edit Tracepoint
                                            </a>
                                        </div>
                                        <div>
                                            <a
                                                className="btn btn-danger"
                                                onClick={() => {
                                                    this.props.terminateTracepoint(tracepoint)
                                                }}
                                            >
                                                Stop Tracepoint
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={'tracepoint-details-actions tw-pr-16'}>
                                        <div className="tw-mr-12">
                                            <form method="POST" action={duplicateUrl}>
                                                <input type="hidden" name="tracepointId" value={tracepoint.id} />
                                                <button className="btn btn-default" type="submit">
                                                    <i className="fa fa-repeat" /> Start Again
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </BoxBody>
                    </Box>
                </PortalContentNavigation>
                {this.state.view === 'show' ? (
                    <ProfileList
                        showTabs={false}
                        fixedCriteria={{ cid: true }}
                        listRoute={'XhprofProfilerBundle.Profile.tracepoint'}
                        params={{}}
                    />
                ) : (
                    <EditTracepointForm
                        tracepoint={tracepoint}
                        allowedDurations={allowedDurationsForTracepoints(this.props.tidewaysContext)}
                        onExit={() => this.setState({ view: 'show' })}
                    />
                )}
            </>
        )
    }

    private setInterval(tracepointId: string) {
        this.interval = setInterval(() => {
            if (!this.state.browserActive) {
                return
            }
            if (this.props.tracepoint && this.props.tracepoint.activeUntil < moment()) {
                clearInterval(this.interval)
                return
            }
            this.props.fetchTracepoint(tracepointId)
        }, 60_000)
    }

    private registerCallback(tracepointId: string) {
        this.visibilityIndex = this.visibility.registerCallBack(
            () => this.setState({ browserActive: false }),
            () => {
                this.props.fetchTracepoint(tracepointId)
                this.setState({ browserActive: true })
            },
        )
    }
}

export const TracepointDetails = connect<StateProps, DispatchProps, RouteComponentProps<MatchParameters>>(
    (globalState: ApplicationState, props: Props): StateProps => {
        return {
            tidewaysContext: globalState.tidewaysContext,
            tracepoint: getTracepointById(globalState, Number(props.match.params.tracepointId)),
        }
    },
    { fetchTracepoint, terminateTracepoint },
)(TracepointDetailsComponent)
